/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicPromptParser extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicPromptParser");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicPromptParser.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicPromptParser>): BackgroundJobPayloadForPeriodicPromptParser {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicPromptParser(), model);
        BackgroundJobPayloadForPeriodicPromptParser.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicPromptParser>): BackgroundJobPayloadForPeriodicPromptParser {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicPromptParser.newInstance(<BackgroundJobPayloadForPeriodicPromptParser> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicPromptParser) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicPromptParser.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicPromptParser): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicPromptParser.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
